/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { ServiceOrderDTO } from '../../entities/service/OrderDTO'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { domainOrderStatusSchema } from '../domain/orderStatusSchema'
import { domainPaymentMethodSchema } from '../domain/paymentMethodSchema'
import { z } from 'zod'

export const serviceOrderDTOSchema = z.object({
  city_name: z.string(),
  created_at: z.string(),
  from_address: z.string(),
  id: z.number().int(),
  payment_method: z.lazy(() => domainPaymentMethodSchema),
  phone: z.string(),
  price: z.number(),
  status: z.lazy(() => domainOrderStatusSchema),
  to_address: z.string(),
}) as unknown as ToZod<ServiceOrderDTO>